import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Delete, OctagonAlert, Pencil} from "lucide-react";
import {useActions} from "../../app_context";
import useModal from "../../modals";
import {useStorePost} from "../../store";
import useFeedback from "../../utils/use_feedback";
import {useDelete} from "../../api/delete";
import {useNSFW} from "../../api/nsfw";
import {MenuItem, MenuItemIcon, MenuItemText} from './sheet';

const PostManageSheet = styled(({className, postId, onClose}) => {

    const actions = useActions();
    const modal = useModal();
    const {post} = useStorePost(postId);
    const {feedbackCh} = useFeedback(true);
    const _delete = useDelete(feedbackCh);
    const nsfw = useNSFW(feedbackCh);

    const handleEdit = () => {

        modal.open('EditPost', {postId});
        onClose();

    };

    const handleDelete = async () => {
        onClose();
        const action = actions.postDeleted(postId);
        try {
            await _delete(postId, 'post');
        } catch {
            action.undo?.();
        }
    };
    const handleNSFW = async () => {
        onClose();
        const action = actions.postNsfw(post.id, !post.is_nsfw);
        try {
            nsfw(postId, !post.is_nsfw);
        } catch (ex) {
            action.undo?.();
        }
    };

    return (
        <div className={className}>
            {post.type === "text" &&
                <MenuItem onClick={handleEdit}>
                    <MenuItemIcon>
                        <Pencil size={24} />
                    </MenuItemIcon>
                    <MenuItemText>
                        Edit
                    </MenuItemText>
                </MenuItem>
            }
            <MenuItem onClick={handleNSFW}>
                <MenuItemIcon>
                    <OctagonAlert size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Set {post.is_nsfw ? 'SFW' : 'NSFW'}
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={handleDelete}>
                <MenuItemIcon>
                    <Delete size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Delete
                </MenuItemText>
            </MenuItem>
        </div>
    );
})``;

export default PostManageSheet;
